import { useContext, useState } from 'react';
import { Table, Row, Col, Badge } from 'reactstrap';
import PageContainer from 'common/PageContainer';
import PageLoader from 'common/PageLoader';
import { BookingsContextDetail } from './bookingContextDetail';
import Header from 'components/Header';
import moment from 'moment';
import { useNavigate } from 'react-router';
// import ChefAssignModel from 'common/ChefAssignModel';
import ChefAssignModel from 'pages/Customers/components/CustomerDetail/components/Booking/ChefAssign';

const BookingDetail = () => {
  const navigate = useNavigate();

  const [showChefModal, setShowChefModal] = useState<boolean>(false);

  const contextValue = useContext(BookingsContextDetail);
  const { isLoading, status, error, data } = contextValue?.userDetail || {};
  console.log('........... indexhjk...', data);

  const handleNavigaeToCustomerDetail = (customerId: any) => {
    console.log('Customer Details:', customerId);
    navigate(`/app/customers/${customerId}/details`, {
      state: { heading: 'Customer Details', iconClass: 'bi bi-chevron-left' },
    });
  };

  const CustomerDetails = (customerId: any) => {
    handleNavigaeToCustomerDetail(customerId);
  };

  if (isLoading) return <PageLoader />;
  if (error) {
    return <span>Something went wrong!</span>;
  }
  if (status === 200 && !data) return <span>No data found!</span>;
  if (status === 200) {
    return (
      <>
        <PageContainer>
          <Header totalCount={null} heading={'Booking Details'} />
          <Row className="mt-4">
            <h5>Details</h5>
            <Table responsive size="sm" striped className="bookingTable mt-3">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Requirement</th>
                  <th>Meals</th>
                  <th>Person</th>
                  <th>Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Chef</th>
                  <th>Rating</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{data?.id || 'N/A'}</td>
                  <td>{data?.requirement || 'N/A'}</td>
                  <td>
                    {data?.meals?.length
                      ? data.meals
                          .map(
                            (meal) =>
                              meal.charAt(0).toUpperCase() + meal.slice(1),
                          )
                          .join(', ')
                      : 'N/A'}
                  </td>

                  <td>{data?.headCount || 'N/A'}</td>
                  <td>
                    {data?.startDate
                      ? moment(data.startDate).format('DD/MM/YYYY')
                      : 'N/A'}
                  </td>

                  <td>
                    {data?.startTime
                      ? moment(
                          data.startTime.replace('.', ':').toUpperCase(),
                          'h:mm A',
                        ).format('hh:mm A')
                      : 'N/A'}
                  </td>

                  <td>
                    {data?.endTime
                      ? moment(
                          data.endTime.replace('.', ':').toUpperCase(),
                          'h:mm A',
                        ).format('hh:mm A')
                      : 'N/A'}
                  </td>
                  <td>
                    <span>
                      {data?.chef?.firstName
                        ? `${data.chef.firstName} ${data.chef.lastName ?? ''}`
                        : 'Unassigned'}
                    </span>

                    {/* ICON */}
                    <i
                      className={`bi ${
                        data?.chef?.firstName
                          ? 'bi-pencil-square'
                          : 'bi-person-plus'
                      }`}
                      style={{ cursor: 'pointer', color: '#dc3545', marginLeft:'10px'}}
                      onClick={() => setShowChefModal(true)}
                    />
                    {
                      <ChefAssignModel
                        show={showChefModal}
                        bookingId={data?.id || null}
                        onClose={() => setShowChefModal(false)}
                      />
                    }
                  </td>
                  <td>{data?.chefRating?.rating || 'N/A'}</td>
                </tr>
              </tbody>
            </Table>

            <Table responsive size="sm" striped className="bookingTable mt-3">
              <thead>
                <tr>
                  <th>Create Date</th>
                  <th>Menu</th>
                  <th>Note</th>
                  <th>Address</th>
                  <th>Venue</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {data?.createdAt
                      ? moment(data.createdAt)
                          .format('DD/MM/YYYY, hh:mm A')
                          .toUpperCase()
                      : 'N/A'}
                  </td>
                  <td>
                    {data?.menu
                      ? data.menu.charAt(0).toUpperCase() +
                        data.menu.substring(1)
                      : 'N/A'}
                    <span>
                      <i
                        className="bi bi-pencil-square ms-2"
                        style={{ color: 'red' }}
                      ></i>
                    </span>
                  </td>
                  <td>{data?.description || 'N/A'}</td>
                  <td>
                    {data?.billingAddress?.address || 'N/A'},{' '}
                    {data?.billingAddress?.city}, {data?.billingAddress?.zip} [
                    {data?.billingAddress?.region}]
                  </td>
                  <td>
                    {data?.venue?.address || 'N/A'}, {data?.venue?.city},{' '}
                    {data?.venue?.zip} [{data?.venue?.region}]
                  </td>
                </tr>
              </tbody>
            </Table>

            <h5 className="section-title mt-3">Payment Details</h5>
            <Table responsive size="sm" striped className="bookingTable mt-3">
              <thead>
                <tr>
                  <th>Advance Payment</th>
                  <th>Remaining Payment</th>
                  <th>Chef Fare</th>
                  <th>additional service Fare</th>
                  <th>tax</th>

                  <th>Discount Code</th>
                  <th>Discount Amount</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span>
                      {data?.fareObject?.advance || '250'}
                      <Badge className="payment-badge ms-2" color="light">
                        Received
                      </Badge>
                    </span>
                  </td>
                  <td>
                    <span>
                      {data?.fareObject?.remainingFare || '750'}
                      <Badge
                        className="payment-pending-badge ms-2"
                        color="light"
                      >
                        Pending
                      </Badge>
                    </span>
                  </td>
                  <td>{data?.fareObject?.chefFare}</td>
                  <td>{data?.fareObject?.additionalServicesFare}</td>
                  <td>{data?.fareObject?.tax}</td>
                  <td>{data?.coupon?.code || 'DYO12344'}</td>
                  <td>{data?.coupon?.discountAmount || '100'}</td>
                  <td>{data?.fareObject?.totalPrice || '1100'}</td>
                </tr>
              </tbody>
            </Table>

            <Row className="contact-details mt-5">
              <h5 className="mt-3">Contact Details</h5>
              <Col sm={12} className="mt-3">
                <h6 className="adminLabel">
                  User Id:{' '}
                  <span className="adminDetail">{data?.user?.id || 'N/A'}</span>
                </h6>
              </Col>
              <Col sm={12}>
                <h6 className="adminLabel">
                  User Name:
                  <span className="adminDetail">
                    {data?.user?.firstName
                      ? data.user.firstName.charAt(0).toUpperCase() +
                        data.user.firstName.substring(1)
                      : 'N/A'}{' '}
                    {data?.user?.lastName
                      ? data.user.lastName.charAt(0).toUpperCase() +
                        data.user.lastName.substring(1)
                      : 'N/A'}{' '}
                    <i
                      onClick={() =>
                        handleNavigaeToCustomerDetail(data?.user?.id)
                      }
                      className="bi bi-arrow-right-square ms-1"
                      style={{ color: 'red', cursor: 'pointer' }}
                    ></i>
                  </span>
                </h6>
              </Col>
              <Col sm={12}>
                <h6 className="adminLabel">
                  Phone:{' '}
                  <span className="adminDetail">
                    {data?.user?.phone || 'N/A'}
                  </span>
                </h6>
              </Col>
              <button
                className="mt-3 ms-2 border bg-transparent w-auto"
                onClick={() => CustomerDetails(data?.user?.id)}
              >
                View Details
              </button>
            </Row>
          </Row>
        </PageContainer>
      </>
    );
  }
  return <span>No data!</span>;
};

export default BookingDetail;
